import { z } from 'zod';

export const VehicleBrandSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
});

export type VehicleBrand = z.infer<typeof VehicleBrandSchema>;

export const ListVehicleBrandsResponseSchema = z.object({
  items: z.array(VehicleBrandSchema),
});

export type ListVehicleBrandsResponse = z.infer<typeof ListVehicleBrandsResponseSchema>;

export const VehicleModelSchema = z.object({
  id: z.uuid(),
  brandId: z.uuid(),
  name: z.string(),
  slug: z.string(),
});

export type VehicleModel = z.infer<typeof VehicleModelSchema>;

export const ListVehicleModelsResponseSchema = z.object({
  items: z.array(VehicleModelSchema),
});

export type ListVehicleModelsResponse = z.infer<typeof ListVehicleModelsResponseSchema>;

export const VehicleEngineSchema = z.object({
  id: z.uuid(),
  description: z.string(),
  displacementCc: z.number().int().nonnegative().nullable(),
});

export type VehicleEngine = z.infer<typeof VehicleEngineSchema>;

export const ListVehicleEnginesResponseSchema = z.object({
  items: z.array(VehicleEngineSchema),
});

export type ListVehicleEnginesResponse = z.infer<typeof ListVehicleEnginesResponseSchema>;

export const VehicleGenerationSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
  yearFrom: z.number().int().nullable(),
  yearTo: z.number().int().nullable(),
});

export type VehicleGeneration = z.infer<typeof VehicleGenerationSchema>;

export const ListVehicleGenerationsResponseSchema = z.object({
  items: z.array(VehicleGenerationSchema),
});

export type ListVehicleGenerationsResponse = z.infer<typeof ListVehicleGenerationsResponseSchema>;

export const VehicleTrimSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
});

export type VehicleTrim = z.infer<typeof VehicleTrimSchema>;

export const ListVehicleTrimsResponseSchema = z.object({
  items: z.array(VehicleTrimSchema),
});

export type ListVehicleTrimsResponse = z.infer<typeof ListVehicleTrimsResponseSchema>;

export const CreateVehicleBrandBodySchema = z.object({
  name: z.string().trim().min(1).max(255),
});

export type CreateVehicleBrandBody = z.infer<typeof CreateVehicleBrandBodySchema>;

export const CreateVehicleBrandResponseSchema = VehicleBrandSchema;

export type CreateVehicleBrandResponse = VehicleBrand;

export const CreateVehicleModelBodySchema = z.object({
  name: z.string().trim().min(1).max(255),
});

export type CreateVehicleModelBody = z.infer<typeof CreateVehicleModelBodySchema>;

export const CreateVehicleModelResponseSchema = VehicleModelSchema;

export type CreateVehicleModelResponse = VehicleModel;
